<template>
  <div :class="['pa-2', 'cd-flex', 'border-container', 'ma-2']">
    <div class="font-weight-medium subheading" style="width: 70%">
      <p class="mb-0">{{ access.name }}</p>
      <p class="mb-0 grey--text text--darken-2">
        Tipo:
        <span class="font-weight-regular">{{ getGateType }}</span>
      </p>
      <p class="mb-0 grey--text text--darken-2">
        Función:
        <span class="font-weight-regular">{{ getDirection }}</span>
      </p>
      <p class="mb-0 grey--text text--darken-2">
        Identificador:
        <span class="font-weight-regular">{{ access.identifier }}</span>
      </p>
    </div>
    <div
      style="
        width: 30%;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
      "
    >
      <QrGenerator :hide="true" :access="access" />
      <v-btn small icon>
        <v-icon color="black" @click="update">edit</v-icon>
      </v-btn>
      <v-btn small icon>
        <v-icon color="black" @click="remove">delete</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import QrGenerator from '../../../../generic/qrGenerator.vue'

export default {
  props: ['access'],
  components: {
    QrGenerator,
  },
  data: () => ({
    qrFile: undefined,
  }),
  methods: {
    update() {
      this.$emit('update')
    },
    remove() {
      this.$emit('delete')
    },
  },
  computed: {
    getGateType() {
      const temp = {
        DOOR: 'Puerta',
        BARRIER: 'Pluma',
        TURNSTILE: 'Torniquete',
      }

      return temp[this.access.gateType]
    },
    getDirection() {
      const temp = {
        IN: 'Entrada',
        OUT: 'Salida',
      }

      return temp[this.access.direction]
    },
  },
}
</script>

<style scoped>
.border-container {
  padding: 1px;
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
}
.cd-flex {
  display: flex;
  transition: background-color 0.3s ease-out;
}
.cd-flex:hover {
  background-color: var(--v-gray-lighten3);
}
</style>
